export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-03.3ada574b.svg";